const noop = () => undefined;

const logger = {
    debug: noop,
    info: noop,
    warn: noop,
    error: noop,
};

// TV builds omit browser monitoring because current Datadog bundles use BigInt
// syntax that older Tizen and webOS engines cannot parse.
export const datadogLogs = { init: noop, logger };
export const datadogRum = {
    init: noop,
    startSessionReplayRecording: noop,
    stopSessionReplayRecording: noop,
    addAction: noop,
    addError: noop,
    setUser: noop,
    clearUser: noop,
};
